import { useEffect, useState } from "react";
import Card from "../../components/card/Card";
import style from "./Sistema.module.css";
import SistemaApi from "../../services/SistemaApi";
import Topbar from "../../components/topbar/Topbar";
import Sidebar from "../../components/sidebar/Sidebar";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import ModalExcluir from "../../components/modalExcluir/ModalExcluir";
import ModalEditar from "../../components/modalEditar/ModalEditar";
import { Button, Form } from "react-bootstrap";
import Alerta from "../../components/alerta/Alerta";
import Loader from "../../components/loader/Loader";
import { Link } from "react-router-dom";
import { MdClose, MdDelete, MdEdit, MdSearch } from "react-icons/md";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import Paginacao from "../../components/paginacao/Paginacao";
import { IoLinkOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";


export default Sistema;

function Sistema() {
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);
  const [dados, setDados] = useState([]); //Tras a lista de sistemas

  const [sistemaSelecionado, setSistemaSelecionado] = useState(null); // Seleciona o id do card Sistema para buscar o objeto Sistema

  const [mostrarModalExcluir, setMostarModalExcluir] = useState(false); // Abre modal excluir
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false); // Abre modal Editar

  //Para exibir o alerta
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  // Tabela paginação

  const [quantidadeItens, setQuantidadeItens] = useState(0);
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [nomeFiltro, setNomeFiltro] = useState("");
  const [descricaoFiltro, setDescricaoFiltro] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1);


  const [loading, setLoading] = useState(false);
  //Função para exibir o alerta
  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 10000);
  };

  const location = useLocation();

  const CarregarSistemas = async (paginaAtual, nome, descricao) => {
    try {
      const listarSistemas = await SistemaApi.ListarSistemasComPaginacaoAsync(
        paginaAtual, 
        nome, 
        descricao
      );
      setQuantidadeItens(listarSistemas.quantidadeRegistros);
      setDados(listarSistemas.registros);

    } catch (error) {
      console.error("Erro ao carregar sistema:", error);
    }
  };

  //Função para filtro de busca
  async function BuscarGrupoDeUsuarios() {
    setNome(nomeFiltro);
    setDescricao(descricaoFiltro);
    setPaginaAtual(1);

  }

  //Função para resetar  filtro de busca
  async function ResetarGrupoDeUsuarios() {
    setNome("");
    setDescricao("");
    setNomeFiltro("");
    setDescricaoFiltro("");
    setPaginaAtual(1);

  }


  const handleAbrirModalExcluir = (id) => {
    setSistemaSelecionado(id);
    setMostarModalExcluir(true);
  };

  const handleFecharModal = () => {
    setSistemaSelecionado(null);
    setMostrarModalEditar(false);
    setMostarModalExcluir(false);
  };

  const handleAbrirModalEditar = async (id) => {
    // o modal abrir precisei buscar o id para modificar, ja que o modal
    if (id) {
      // é um componente e não estava conseguindo trazer o id do sistema
      try {

        const obterSistema = await SistemaApi.ObterSistema(id);
        setSistemaSelecionado(obterSistema);
        setMostrarModalEditar(true);
      } catch (error) {
        console.error("Erro ao carregar sistema: ", error);
      }
    }
  };

  const handleEditarSistema = async () => {
    if (sistemaSelecionado) {
      try {
        setLoading(true);
        await SistemaApi.AtualizarSistema(sistemaSelecionado);
        setMensagemAlerta("Sistema atualizado com sucesso.");
        setTipoAlerta("success");
        exibirAlerta();
        CarregarSistemas();
      } catch (error) {
        setMensagemAlerta("Falha ao atualizar Sistema.");
        setTipoAlerta("danger");
        exibirAlerta();
      } finally {
        handleFecharModal();
        setLoading(false);
      }
    } else {
      console.error("Nenhum id sistema selecionado");
    }
  };

  const confirmarDesativacao = async () => {
    // estou chamando no componente modal, onde passo o id pela rota e o conteudo pelo payload
    if (sistemaSelecionado) {
      try {
        setLoading(true);
        await SistemaApi.DesativarSistema(sistemaSelecionado);
        setMensagemAlerta("Sistema desativado com sucesso.");
        setTipoAlerta("success");
        exibirAlerta();
        CarregarSistemas();
      } catch (error) {
        setMensagemAlerta("Falha ao desativar Sistema.");
        setTipoAlerta("danger");
        exibirAlerta();
      } finally {
        handleFecharModal();
        setLoading(false);
      }
    } else {
      console.error("Nenhum id sistema selecionado");
    }
  };

  useEffect(() => {
    // Aqui só esta redenrizando a lista de Sistemas

    CarregarSistemas(paginaAtual, nome, descricao)
    if (location.state?.mensagem && location.state?.tipo) {
      setMensagemAlerta(location.state.mensagem);
      setTipoAlerta(location.state.tipo);
      setMostrarAlerta(true);

      // Fecha o alerta automaticamente após 5 segundos
      setTimeout(() => {
        setMostrarAlerta(false);
      }, 3000);

      // Limpa o state da URL para não exibir alerta de novo
      window.history.replaceState({}, document.title);
    }
  }, [paginaAtual, nome, descricao]);

  const totalPages = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados


  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar
        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}
      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}
        <div className={style.pagina_conteudo}>
          <div className={style.container_cabecalho}>
            <h4>Sistemas</h4>
            <BotaoNovo link={"/backoffice/sistema/novo"} />
          </div>
          {/* 
          <div className={style.content_wrapper}>
            <div className={style.wrapper}>
              {dados.length === 0 ? (
                <p>Lista de Sistemas esta vazio</p>
              ) : (
                dados.map((item) => (
                  <Card
                    key={item.id}
                    id={item.id}
                    titulo={item.nome}
                    url={item.url}
                    abrirModalExcluir={handleAbrirModalExcluir}
                    abrirModalEdiatr={handleAbrirModalEditar}
                  />
                ))
              )}
            </div>
          </div> */}

          {/* Filtro de pesquisa */}
          <div className={style.container_filtro}>
            <InputBuscar
              type="text"
              id="hidenNome"
              placeholder="Nome"
              name="nome"
              maxLength={30}
              value={nomeFiltro}
              onChange={(e) => setNomeFiltro(e.target.value)}
            />

            <InputBuscar
              type="text"
              id="hidenDescricao"
              placeholder="Descrição"
              name="descricao"
              maxLength={70}
              value={descricaoFiltro}
              onChange={(e) => setDescricaoFiltro(e.target.value)}
            />
            <div className={style.container_filtro2}>

              <Button onClick={BuscarGrupoDeUsuarios} id={style.botao_buscar}><MdSearch /> Buscar
              </Button>

              <Button onClick={ResetarGrupoDeUsuarios} id={style.botao_resetar}><MdClose /> Limpar
              </Button>

            </div>

          </div>

          <div className={style.container_tabela_paginacao}>
            {/* Tabela*/}
            <div className={style.tabela_responsiva}>
              <table className={style.container_tabela}>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Descrição</th>
                    <th className={style.coluna_acoes}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {dados.map((item) => (
                    <tr key={item.id}>
                      <td title={item.nome}>{item.nome}</td>
                      <td title={item.descricao}>{item.descricao}</td>
                      <td className={style.coluna_acoes}>

                        <Link
                          title="Link"
                          to={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={style.botao_visualizar}
                        >
                          <IoLinkOutline />
                        </Link>
                        <Link
                          onClick={() => handleAbrirModalEditar(item.id)}
                          className={style.botao_editar}
                        >
                          <MdEdit
                            title="Editar" />
                        </Link>
                        <Link
                          onClick={() => handleAbrirModalExcluir(item.id)}
                          className={style.botao_deletar}
                        >
                          <MdDelete
                            title="Deletar" />
                        </Link>


                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Controle de Paginação */}
            <Paginacao
              paginaAtual={paginaAtual}
              totalPages={totalPages}
              onPageChange={(novaPagina) => setPaginaAtual(novaPagina)}
            />
          </div>
          <ModalExcluir
            isOpen={mostrarModalExcluir}
            onClose={handleFecharModal}
            onConfirm={confirmarDesativacao}
            Mensagem="Deseja desativar este Sistema?"
          />
          <ModalEditar
            isOpen={mostrarModalEditar}
            onClose={handleFecharModal}
            mensagem="Editar Sistema"
            onConfirm={handleEditarSistema}
          >
            <Form.Group
              controlId="formDescricao"
              className={`mb-3; ${style.formulario}`}
            >
              <div>
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nome"
                  name="nome"
                  value={sistemaSelecionado?.nome || ""}
                  onChange={(e) =>
                    setSistemaSelecionado({
                      ...sistemaSelecionado,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Descrição"
                  name="descricao"
                  value={sistemaSelecionado?.descricao || ""}
                  onChange={(e) =>
                    setSistemaSelecionado({
                      ...sistemaSelecionado,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <Form.Label>Url</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Url"
                  name="url"
                  value={sistemaSelecionado?.url || ""}
                  onChange={(e) =>
                    setSistemaSelecionado({
                      ...sistemaSelecionado,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
            </Form.Group>
          </ModalEditar>
        </div>
      </Topbar>
    </Sidebar >
  );
}
